import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Commission } from 'src/model/commission.model';
import { Loan } from 'src/model/loan.model';
import { LoanGroup } from 'src/model/loanGroup.model';
import { CommissionService } from 'src/services/commission.service';
import { LoanGroupService } from 'src/services/loan-group.service';
import { LoanService } from 'src/services/loan.service';

@Component({
    selector: 'app-override-comm-limit',
    templateUrl: './override-comm-limit.component.html',
    styleUrl: './override-comm-limit.component.scss',
    standalone: false
})
export class OverrideCommLimitComponent implements OnInit, OnChanges {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private lgService = inject(LoanGroupService);
  private loanService = inject(LoanService);
  private commissionService = inject(CommissionService);

  @Input() remark: string;
  @Input() commLimit: number;
  @Output() result = new EventEmitter<any>();

  @Input() loanGroupId: number;
  @Input() loanId: number;
  @Input() loan: Loan;
  @Input() isModal = true;

  maxCommRate: number;
  assignedCommissionList: Commission[] = [];

  @Input() loanGroup: LoanGroup;

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.gettingCommissionInfo();
  }

  async ngOnInit(): Promise<void> {
    this.gettingCommissionInfo();
  }

  async gettingCommissionInfo() {
    this.assignedCommissionList = await this.commissionService.getLoanCommissions(this.loan.ID);
    if (this.loanGroup == undefined)
      this.loanGroup = await this.lgService.getSingleLoanGroup(this.loanGroupId);
    if (this.loan == undefined)
      this.loan = await this.loanService.getLoanById(this.loanId);
    this.maxCommRate = this.sharedService.getMaxCommissionRate(this.loan) * 100;
  }

  reset() {
    this.activeModal.close();
  }

  confirmBeforeUpdate() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to update the commission of " + this.loan.CustomerName + " to " + this.commLimit + "%?";

    modalRef.result.then((confirm) => {
      if (confirm) {
        this.overrideCommLimit();
      }
    });
  }

  async overrideCommLimit() {
    const lgUpdate = new LoanGroup(undefined, undefined, undefined, this.loanGroupId, undefined, this.remark, this.commLimit)
    const result = this.lgService.getOverrideLgCommRateLimit(lgUpdate);

    if (result != undefined)
      this.result.emit(lgUpdate);

    this.sharedService.openAlert("Successfully updated commission rate", ALERT_TYPE.SUCCESS);
    this.reset();
  }
}
